import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import { IpcPingReply, EndResult, WebIpcClient } from '../../node_modules/@verisure/mykmp-webipc/mykmp-webipc.js';
import { logIfVerbose, errorIfVerbose } from './loggingControl.js';

var commandHandler = {
    onPing: function (msg) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            logIfVerbose("Was pinged by native: ".concat(msg));
            return [2 /*return*/, new IpcPingReply('Ok')];
        });
    }); },
};
// Singleton implementation for IpcState
var IpcStateManager = /** @class */ (function () {
    function IpcStateManager() {
        this.state = {
            client: new WebIpcClient(),
            connection: null,
            connecting: null,
        };
    }
    IpcStateManager.getInstance = function () {
        if (!IpcStateManager.instance) {
            IpcStateManager.instance = new IpcStateManager();
        }
        return IpcStateManager.instance;
    };
    IpcStateManager.prototype.getState = function () {
        return this.state;
    };
    return IpcStateManager;
}());
// Get the state from the singleton manager
var getState = function () { return IpcStateManager.getInstance().getState(); };
// Reset function for testing purposes
var resetStateForTesting = function () {
    var state = getState();
    state.connection = null;
    state.connecting = null;
};
var connect = function () {
    var state = getState();
    if (state.connection) {
        return Promise.resolve(state.connection);
    }
    if (state.connecting) {
        return state.connecting;
    }
    state.connecting = state.client
        .connect(commandHandler)
        .then(function (conn) {
        logIfVerbose('Connected to IPC', conn);
        state.connection = conn;
        return conn;
    })
        .catch(function (err) {
        errorIfVerbose('Failed to connect to IPC', err);
        state.connecting = null;
        throw err;
    });
    return state.connecting;
};
var isConnected = function () { return Boolean(getState().connection); };
var ping = function () {
    var state = getState();
    if (!state.connection) {
        return Promise.reject(new Error('Not connected to IPC'));
    }
    return state.connection.commands.ping();
};
var beginSession = function (showNativeHeader) {
    if (showNativeHeader === void 0) { showNativeHeader = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var state;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    if (!state.connection && !state.connecting) {
                        return [2 /*return*/, Promise.reject(new Error('Not connected to IPC'))];
                    }
                    if (!(state.connecting && !state.connection)) return [3 /*break*/, 2];
                    return [4 /*yield*/, state.connecting];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!state.connection) {
                        return [2 /*return*/, Promise.reject(new Error('Connection failed'))];
                    }
                    return [2 /*return*/, state.connection.commands.beginSession(showNativeHeader)];
            }
        });
    });
};
var getEndRouteFromString = function (route) {
    if (!route) {
        return EndResult.GoBack;
    }
    return new EndResult.GoHome(route);
};
var endSession = function (route) {
    var state = getState();
    if (!state.connection) {
        return Promise.reject(new Error('Not connected to IPC'));
    }
    var endResult = getEndRouteFromString(route);
    logIfVerbose('Ending IPC session', endResult);
    return state.connection.commands.endSession(endResult);
};
var generateError = function (error) {
    var state = getState();
    if (!state.connection) {
        return Promise.reject(new Error('Not connected to IPC'));
    }
    return state.connection.commands.generateError(error);
};
var getAppFeatureManifest = function () {
    var state = getState();
    if (!state.connection) {
        throw new Error('Not connected to IPC');
    }
    return state.connection.appInfo.supports;
};
var getDigSigAvailability = function () {
    var state = getState();
    if (!state.connection) {
        throw new Error('Not connected to IPC');
    }
    return state.connection.commands.getDigSigAvailability();
};
var getDigSigSignature = function (data) {
    var state = getState();
    if (!state.connection) {
        throw new Error('Not connected to IPC');
    }
    return state.connection.commands.getDigSigSignature(data);
};
var ipcService = {
    isConnected: isConnected,
    connect: connect,
    ping: ping,
    beginSession: beginSession,
    endSession: endSession,
    generateError: generateError,
    getAppFeatureManifest: getAppFeatureManifest,
    getDigSigAvailability: getDigSigAvailability,
    getDigSigSignature: getDigSigSignature,
    resetStateForTesting: resetStateForTesting,
};

export { beginSession, connect, ipcService as default, endSession, generateError, getAppFeatureManifest, getDigSigAvailability, getDigSigSignature, getEndRouteFromString, isConnected, ping, resetStateForTesting };
